import { DefaultSettingsModel } from '../../valutrust-mapper-types/model/valuetrust.model';
import { DefaultSettingsModel as FNCDefaultSettingsModel } from '../../fnc-mapper-types/fnc-default-setting/model/fnc-default-setting.model';
import { AssetOnCompletionModel } from '../../components/messages/model/data-message.model';

export const GlobalConfig_STATE_PATH = 'globalConfiguration';

export class GlobalConfigurationStateModel {
	acuity: {
		products?: ProductsList[];
		lenderBranches?: ProductsList[];
		documentTypes?: IdNameObjectType[];
		loanTypes?: IdNameObjectType[];
		loanReasons?: IdNameObjectType[];
		propertyTypes?: IdNameObjectType[];
		occupancyTypes?: IdNameObjectType[];
		insideMapsProducts?: ProductsList[];
		milestones?: ProductsList[];
		assetsOnCompletion?: Array<AssetOnCompletionModel>
	};
	appScope: {
		products?: ProductsList[];
		documentTypes?: IdNameObjectType[];
		loanTypes?: IdNameObjectType[];
		loanReasons?: IdNameObjectType[];
		propertyTypes?: IdNameObjectType[];
		occupancyTypes?: IdNameObjectType[];
		lenders?: ProductsList[];
		assetsOnCompletion?: Array<AssetOnCompletionModel>
	};
	cmpAcuity: {
		products?: ProductsList[];
		documentTypes?: IdNameObjectType[];
		loanTypes?: IdNameObjectType[];
		loanReasons?: IdNameObjectType[];
		propertyTypes?: IdNameObjectType[];
		occupancyTypes?: IdNameObjectType[];
		lenders?: ProductsList[];
		milestones?: ProductsList[];
	};
	classValuation: {
		documentTypes?: IdNameObjectType[];
		docTypes?: IdNameObjectType[];
	}
	classIntelligence: {
		formTypes ?: any[];
		origins ?: any[];
		organizations ?: any[];
	};
	nexsys: {
		products?: ProductsList[];
		attributesList?: ProductsList[];
		statusMessageAppScope ?: any[];
		statusMessageAcuity ?: any[];
		statusMessageCmpAcuity ?: any[];
	};
	valuTrust: {
		products?: ProductsList[];
		statusMessageAppScope ?: any[];
		statusMessageAcuity ?: any[];
		statusMessageCmpAcuity ?: any[];
	};
	xpanse: {
		products?: ProductsList[];
		defaultSettings? :DefaultSettingsModel
	};
	fnc: {
		products?: ProductsList[];
		defaultSettings? :FNCDefaultSettingsModel
	};
	genericIntegrations: {
		integrations?: Array<GenericIntegration>;
	}
	deliveryAssets: {
		appScope?: {
			documentTypes?: IdNameObjectType[];
		},
		acuity?: {
			documentTypes?: IdNameObjectType[];
		},
		classValuation?: {
			documentTypes?: IdNameObjectType[];
		},
		cmpAcuity?: {
			documentTypes?: IdNameObjectType[];
		}
	}

	schemaList: IdNameObjectType[];

	constructor() {
		this.acuity = {};
		this.appScope = {};
		this.cmpAcuity = {};
		this.classValuation = {};
		this.classIntelligence = {};
		this.nexsys = {};
		this.valuTrust = {};
		this.xpanse = {};
		this.fnc = {};
		this.genericIntegrations = {};
		this.deliveryAssets = {};
	}
}
export interface GenericIntegration {
	integrationId: string;
	integrationName: string;
	updatedBy?: string;
	created?: string;
	updated?: string;
}
export class ProductsList {
	id: string;
	title: string;
}

export class IdTitleObjectType extends ProductsList {
}

export interface IdNameObjectType {
	id: string;
	name: string;
}
